import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import logo from '../../logo.png';
import './GuestLogin.css';

const LoginPage = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { demoLogin } = useAuth();

  const handleDemoLogin = async () => {
    setLoading(true);
    setError('');
    const result = await demoLogin();
    if (!result.success) {
      setError(result.error);
      setLoading(false);
    }
  };

  return (
    <div className="guest-login-container">
      <div className="guest-login-card">
        <div className="guest-login-header">
          <img src={logo} alt="Mini-PLM" className="guest-login-logo" />
          <h1 className="guest-login-title">Mini PLM</h1>
          <p className="guest-login-subtitle">Product lifecycle management for hardware teams</p>
        </div>
        {error && <div className="guest-login-error">{error}</div>}
        <button
          onClick={handleDemoLogin}
          disabled={loading}
          className="guest-login-btn"
        >
          {loading ? 'Loading…' : 'Try Demo'}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
